import styled from 'styled-components';
import { typography } from '@/styles/helpers';

export const ScBenefitItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  padding: 24px;
  width: 100%;
  border-radius: 12px;
  background: radial-gradient(
    161.21% 160.39% at 5.71% -44.13%,
    #363636 0%,
    rgba(26, 26, 26, 0.27) 100%
  );

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: inherit;
    background: linear-gradient(
      135deg,
      #ffffff 0%,
      #ffffff41 33%,
      #ffffffbb 66%,
      #ffffff12 100%
    );
    opacity: 0.3;
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    pointer-events: none;
  }

  & .item-container {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    & .text-wrapper {
      display: flex;
      flex-direction: column;
      & .title {
        color: ${({ theme }) => theme.yellowColor};
        ${typography.headline2mobile};
        font-weight: 700;
        text-transform: uppercase;
      }

      & .subtitle {
        color: ${({ theme }) => theme.whiteColor};
        ${typography.body1bold};
        font-weight: 700;
        text-transform: lowercase;
      }
    }
  }

  & .description {
    color: ${({ theme }) => theme.blackLightColor};
    ${typography.body1bold};
    font-weight: 400;
  }

`;
